import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { defineComponent as _defineComponent } from 'vue';
import { SIcon, SInput } from '@strana-artw/ui-kit';
import { computed, defineComponent, ref, useCssModule } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordChangePart',
  props: {
    formLogic: {
      type: Function,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    defineComponent({
      name: 'PasswordChangePart'
    });
    var _props$formLogic$pass = props.formLogic().password,
      v$ = _props$formLogic$pass.v$,
      errors = _props$formLogic$pass.errors,
      serverErrors = _props$formLogic$pass.serverErrors,
      labels = _props$formLogic$pass.labels,
      placeholders = _props$formLogic$pass.placeholders,
      validatorKeys = _props$formLogic$pass.validatorKeys,
      clearServerError = _props$formLogic$pass.clearServerError,
      formKeys = _props$formLogic$pass.formKeys;
    var successValidationIcon = 'i-check';
    var failedValidationIcon = 'close';
    var $style = useCssModule();
    var validationItems = computed(function () {
      var items = [];
      var _iterator = _createForOfIteratorHelper(validatorKeys),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          var validator = v$.value.form.newPassword[key];
          var valid = !validator.$invalid;
          items.push({
            cssClass: valid ? $style.successfulValidation : $style.failedValidation,
            icon: valid ? successValidationIcon : failedValidationIcon,
            message: validator.$message,
            key: key
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return items;
    });
    var hiddenState = ref({
      currentPassword: true,
      newPassword: true,
      repeatPassword: true
    });
    function toggleVisibleButtonClick(event, key) {
      if (event.type === 'focus' || event.type === 'blur') {
        return;
      }
      hiddenState.value[key] = !hiddenState.value[key];
    }
    return {
      __sfc: true,
      props: props,
      v$: v$,
      errors: errors,
      serverErrors: serverErrors,
      labels: labels,
      placeholders: placeholders,
      validatorKeys: validatorKeys,
      clearServerError: clearServerError,
      formKeys: formKeys,
      successValidationIcon: successValidationIcon,
      failedValidationIcon: failedValidationIcon,
      $style: $style,
      validationItems: validationItems,
      hiddenState: hiddenState,
      toggleVisibleButtonClick: toggleVisibleButtonClick,
      SIcon: SIcon,
      SInput: SInput
    };
  }
});